/*************************************************/
/* MENU                                          */
/*************************************************/

export function menu() {

    const init = function () {
        // Menu burger button click event using plain JavaScript
        document.querySelectorAll(".menu-burger-container").forEach(button => {
            button.addEventListener("click", function () {
                const megaMenu = document.querySelector(".mega-menu");
                const megaMenuMobile = document.querySelector(".mega-menu.mobile");
                const allButtons = document.querySelectorAll(".menu-burger-container");
        
                if (megaMenu.style.display === "block") {
                    megaMenu.style.display = "none";
                } else {
                    megaMenu.style.display = "block";
                }
        
                if (megaMenuMobile.style.display === "block") {
                    megaMenuMobile.style.display = "none";
                } else {
                    megaMenuMobile.style.display = "block";
                }
        
                // Toggle the open class for all buttons
                allButtons.forEach(btn => btn.classList.toggle("open"));
            });
        });
        
        
        // See all click event to show hidden child elements
        document.querySelectorAll(".mega-menu__item--child-more").forEach(function (element) {
            element.addEventListener("click", function () {
                const hiddenChildren = this.parentElement.querySelectorAll(".mega-menu__item--child-hidden");
                hiddenChildren.forEach(function (hiddenChild) {
                    hiddenChild.style.display = "block";
                });
                this.style.display = "none"; // Hide the "See all" link after clicking
            });
        });

        if (window.innerWidth < 992) {
            var toggles = document.querySelectorAll('.accordion-toggle');
            toggles.forEach(function (toggle) {
                toggle.addEventListener('click', function () {
                    var parentItem = this.closest('.mega-menu__item');
                    var childMenu = parentItem.querySelector('.mega-menu__item--child');
                    if (childMenu) {
                        childMenu.classList.toggle('show');
                        if (childMenu.classList.contains('show')) {
                            this.classList.add("accordion-toggle-up")
                        } else {
                            this.classList.remove("accordion-toggle-up")
                        }
                    }
                });
            });
        }
    }
    init();
}